import { useCallback, useEffect } from "react";

import { gtagEvent } from "@/utils/gtag";

export default function useRecordEventOnLoad(
  action: string | null | undefined
) {
  const taggedEvent = useCallback((action) => {
    gtagEvent(action);
  }, []);

  useEffect(() => {
    taggedEvent(action);
  }, [taggedEvent, action]);
}
